'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuestHeader = function (_Component) {
  _inherits(QuestHeader, _Component);

  function QuestHeader(props, context) {
    _classCallCheck(this, QuestHeader);

    return _possibleConstructorReturn(this, (QuestHeader.__proto__ || Object.getPrototypeOf(QuestHeader)).call(this, props, context));
  }

  _createClass(QuestHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var questionnaireTitle = _props.questionnaireTitle;
      var imageSource = _props.imageSource;

      var url = _lodash2.default.get(imageSource, ['url'], '');
      var style = { backgroundImage: 'url(' + url + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover' };
      return _react2.default.createElement(
        'div',
        { className: 'questionnaire-title', style: style },
        _react2.default.createElement(
          'div',
          { className: 'questionnaire-title-container' },
          _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: questionnaireTitle } })
        ),
        this.props.children
      );
    }
  }]);

  return QuestHeader;
}(_react.Component);

exports.default = QuestHeader;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/questionnaire/QuestHeader.js
 ** module id = 814
 ** module chunks = 0
 **/